import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinSlideoversHorizonComponent extends Component {
  @service organisation;
}
